import type { WidgetPreset } from "../types";
import templateHtml from "./template.html?raw";

export const BIG_BRAIN: WidgetPreset = {
  id: "big-brain",
  label: "Big Brain Energy",
  defaultWidth: 160,
  defaultHeight: 160,
  html: templateHtml,
};
